export default __webpack_public_path__ + "static/media/20210205_170203.6831e763.jpg";